import { USER_KEY } from "../services/api.service";
import AuthService from "../services/auth.service";

const user =
  typeof localStorage.getItem(USER_KEY) != "undefined"
    ? JSON.parse(localStorage.getItem(USER_KEY))
    : "";
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };
const authService = new AuthService();
export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    loginViaToken({ commit }, payload) {
      return authService.loginViaToken(payload).then(
        (payload) => {
          commit("loginSuccess", payload);
          return Promise.resolve(payload);
        },
        (error) => {
          // action.setErrors(error.errors);
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    login({ commit }, { payload, action }) {
      if (action) {
        authService.formAnchor = action;
      }
      return authService.login(payload).then(
        (payload) => {
          commit("loginSuccess", payload);
          return Promise.resolve(payload);
        },
        (error) => {
          // action.setErrors(error.errors);
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      authService.logout();
      commit("logout");
    },
    register({ commit }, user) {
      return authService.register(user).then(
        (response) => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        (error) => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
